<template lang="pug">
.v-help-card.help-card(v-if="data")
    .help-card__title(v-if="data.title" @click="open = !open") {{ data.title }}
    v-collapse(:open="open")
        .help-card__collapse
            .help-card__description(v-if="data.description" v-html="data.description" )
</template>

<script>
import sourceMixin from './mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
			open: false
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}
</script>